<template>
  <div class="activity-list">
    <el-tabs v-model="activeName"
             type="card">
      <el-tab-pane label="往期活动"
                   name="end">
        <div class="activity"
             v-for="(item, index) in dataList">
          <div class="homeimg">
            <img :src="getImage(item.image)"
                 width="100%"
                 height="100%" />
          </div>
          <div class="title">
            <p>{{ item.activityName }}</p>
            <el-button round
                       class="fr over"
                       @click="addActive(index, item)">结束</el-button>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="正在进行"
                   name="going">
        <div class="activity"
             v-for="(item, index) in dataList">
          <div class="homeimg">
            <img :src="getImage(item.image)"
                 width="100%"
                 height="100%" />
          </div>
          <div class="title">
            <p>{{ item.activityName }}</p>
            <el-button round
                       class="fr"
                       @click="addActive(index, item)">报名</el-button>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="敬请期待"
                   name="noStart">
        <div class="activity"
             v-for="(item, index) in dataList">
          <div class="homeimg">
            <img :src="getImage(item.image)"
                 width="100%"
                 height="100%" />
          </div>
          <div class="title">
            <p>{{ item.activityName }}</p>
            <el-button round
                       class="fr"
                       @click="addActive(index, item)">报名</el-button>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <float v-show="isToken"></float>
  </div>
</template>
<script>
export default {
  name: "activitylist",
  data () {
    return {
      isActive: "",
      activeName: "end",
      notstartList: [],
      goingList: [],
      endList: [],
      //分页功能
      totalPage: [],
      // 每页显示数量
      pageSize: 100,
      // 共几页
      pageNum: 0,
      // 当前显示的数据
      dataList: [],
      // 默认当前显示第一页
      currentPage: 1,
      isToken: true,//url中是否有token
    };
  },
  mounted () {
    this.$nextTick(() => {
      this.getQueryStringRegExp("token");
      this.getQueryStringRegExp("museumCode");
      //如果获取到小程序传来的token
      if (this.getQueryStringRegExp("token") !== '') {
        this.$store.state.token = this.getQueryStringRegExp("token");
        document.cookie = "code" + "=" + this.getQueryStringRegExp("token");
        this.isToken = false
      } else {
        this.isToken = true
      }
      console.log(this.getQueryStringRegExp("token"));
      console.log(this.getQueryStringRegExp("museumCode"));
      //判断是否由场馆列表页转入
      if (this.getQueryStringRegExp("museumCode") !== "") {
        this.$store.state.museumCode = this.getQueryStringRegExp("museumCode");
      }
      this.getitemList();
    });
    document.body.style.backgroundColor = "#fff";
  },
  methods: {
    getQueryStringRegExp: function getQueryStringRegExp (name) {
      var reg = new RegExp("(^|\\?|&)" + name + "=([^&]*)(\\s|&|$)", "i");
      if (reg.test(location.href))
        return unescape(RegExp.$2.replace(/\+/g, " "));
      return "";
    },
    getImage (val) {
      // alert(val)
      let imgArr = val.split(";");
      // alert(imgArr[0])
      return (
        window.SITE_CONFIG.baseUrl + "/api/activity/web/images/" + imgArr[0]
      );
    },
    addActive (index, item) {
      // this.isActive = index;
      // console.log(this.isActive);
      this.$router.push({
        path: `/things/${item.id}`
      });
    },
    getitemList () {
      console.log(111);
      this.$axios
        .get(
          window.SITE_CONFIG.baseUrl +
          "/api/activity/web/activity?page=" +
          this.currentPage +
          "&limit=" +
          this.pageSize +
          "&type=" +
          encodeURI(this.activeName) +
          "&museumCode=" +
          this.$store.state.museumCode,
          {}
        )
        .then(response => {
          console.log(11111);
          console.log(response.data.data.rows);
          var result = response.data;
          this.dataList = response.data.data.rows;
          this.pageNum = response.data.data.total;
        });
    }
  },
  watch: {
    activeName () {
      this.getitemList();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/activityList/activitylist.vue